<template>
  <div v-editable="blok" class="quote">
    <BaseNuxtImage
      class="author__image"
      :class="[hasBorderClass]"
      :style="[imageSize]"
      :src="(blok.photo && blok.photo.filename) || '/'"
      :alt="blok.photo && blok.photo.alt"
    />
    <div class="author__content">
      <p class="author__name">
        {{ blok.author_name }}
      </p>
      <p class="author__position">
        {{ blok.author_position }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbQuoteAuthorNarrowStoryblok } from '@/types'
interface Props {
  blok: SbQuoteAuthorNarrowStoryblok
}
const props = defineProps<Props>()

const hasBorderClass = computed(() => {
  return props.blok.has_border ? 'author__image--border' : ''
})
const imageSize = computed(() => {
  return {
    '--image-size': `${props.blok.image_size ?? 72}px`,
  }
})
</script>

<style lang="scss" scoped>
.quote {
  display: flex;
  flex-direction: row;

  &__author {
    position: relative;
    display: flex;
    grid-column: span 12;
    align-items: flex-start;
    flex-direction: column;
  }

  &__content {
    grid-column: span 12;

    @media (min-width: $breakpoint-lg) {
      grid-column: 4 / span 9;
      order: 1;
    }
  }
}

.author {
  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__position {
    margin: 0;
  }

  &__image {
    --image-size: 72px;

    max-width: var(--image-size);
    max-height: var(--image-size);
    margin-right: 20px;

    &--border {
      border: 1px solid var(--gray-400);
      border-radius: 50%;
    }
  }

  &__name {
    margin-bottom: 4px;
    font-size: var(--font-size-heading-5);
    font-weight: var(--font-weight-bold);
    line-height: 24px;
    color: var(--color-text);
    font-variant-ligatures: common-ligatures;
    letter-spacing: normal;
  }
}
</style>
